module.exports = __webpack_public_path__ + "img/zhili-1.7d70e20f.jpg";